/**
 * Yayın overlay'lerinin (skorboard + LED ekran) hangi içeriği göstereceğini
 * belirleyen mod sabitleri.
 *
 * Skorboard ve LED ekran BİRBİRİNDEN BAĞIMSIZ seçilir:
 * - Skorboard modu  -> overlay_status (ve eski alan adları)
 * - LED ekran modu  -> led_overlay_status (ve alias'ları)
 */

export const OVERLAY_CONTENT_MODE = Object.freeze({
  SCOREBOARD: "scoreboard",
  SCOREBOARD_V2: "scoreboardv2",
  BOTTOM_BOARD: "bottomboard",
  PRE_MATCH: "pre_match",
  PRE_MATCH_V2: "prematchv2",
  LINEUPS: "lineups",
  LINEUPS_V2: "lineupsv2",
  LINEUPS_V3: "lineupsv3",
  HALFTIME: "halftime",
  POST_MATCH: "post_match",
  // Röportaj: alt ortada skor kartı + konuşan oyuncu(lar) bandı.
  INTERVIEW: "interview",
});

export const LED_CONTENT_MODE = Object.freeze({
  SCOREBOARD: "scoreboard",
  SCOREBOARD_V2: "scoreboardv2",
  PRE_MATCH: "pre_match",
  PLAYERS: "players",
  LINEUP_HOME: "lineup_home",
  LINEUP_AWAY: "lineup_away",
  HIGHLIGHTS: "highlights",
  MVP: "mvp",
  KARE_AS: "kare_as",
  INTERVIEW: "interview",
  VAR_IMAGE: "var",
  VAR_CHECK: "var_check",
  HALFTIME: "halftime",
  POST_MATCH: "post_match",
  SPONSOR: "sponsor",
});

const MODE_FIELDS = [
  "overlay_status",
  "live_overlay_content",
  "overlay_content_mode",
  "overlay_mode",
  "broadcast_overlay_mode",
  "canli_yayin_icerik_modu",
];

const LED_MODE_FIELDS = [
  "led_overlay_status",
  "led_status",
  "led_overlay_content",
  "led_content_mode",
  "led_overlay_mode",
  "canli_led_icerik_modu",
];

export const isOverlayContentMode = (mode) =>
  Object.values(OVERLAY_CONTENT_MODE).includes(mode);

export const isLedContentMode = (mode) =>
  Object.values(LED_CONTENT_MODE).includes(mode);

const unwrap = (value) => {
  const match = value?.data?.data ?? value?.data ?? value;
  return match && typeof match === "object" ? match : null;
};

const readMode = (value, fields, overlayKey, validator) => {
  const match = unwrap(value);
  if (!match) return "";

  const candidates = [
    ...fields.map((field) => match[field]),
    match?.overlay?.[overlayKey],
  ];

  const mode = candidates.find(
    (candidate) => candidate != null && String(candidate).trim()
  );

  const normalizedMode = mode == null ? "" : String(mode).trim().toLowerCase();
  return validator(normalizedMode) ? normalizedMode : "";
};

export const readOverlayContentMode = (value) =>
  readMode(value, MODE_FIELDS, "mode", isOverlayContentMode);

export const readLedContentMode = (value) =>
  readMode(value, LED_MODE_FIELDS, "ledMode", isLedContentMode);
